import { render, staticRenderFns } from "./UpgradeCard.vue?vue&type=template&id=e3dbd12c&scoped=true"
import script from "./UpgradeCard.vue?vue&type=script&lang=ts"
export * from "./UpgradeCard.vue?vue&type=script&lang=ts"
import style0 from "./UpgradeCard.vue?vue&type=style&index=0&id=e3dbd12c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3dbd12c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3dbd12c')) {
      api.createRecord('e3dbd12c', component.options)
    } else {
      api.reload('e3dbd12c', component.options)
    }
    module.hot.accept("./UpgradeCard.vue?vue&type=template&id=e3dbd12c&scoped=true", function () {
      api.rerender('e3dbd12c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/UpgradeCard.vue"
export default component.exports